import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'types';
import { initialState } from '.';

const selectSlice = (state: RootState) => state.globalAudio || initialState;

export const selectCurrentSong = createSelector(
    selectSlice,
    globalAudio => globalAudio?.currentSong,
);

export const selectIsPlaying = createSelector(
    selectSlice,
    globalAudio => globalAudio?.isPlaying,
);

export const selectProgress = createSelector(
    selectSlice,
    globalAudio => globalAudio?.progress,
);

export const selectSeekToProgress = createSelector(
    selectSlice,
    globalAudio => globalAudio?.seekToProgress,
);

export const selectQueue = createSelector(
    selectSlice,
    globalAudio => globalAudio?.queue,
);

export const selectHistoryStack = createSelector(
    selectSlice,
    globalAudio => globalAudio?.historyStack,
);

